var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

import React from 'react';
import PropTypes from 'prop-types';
import { reduxForm, isInvalid, submit as _submit } from 'redux-form';
import createFields from './create-fields';
/**
 * Generate a redux form from a schema.
 * @param {object} UIKit - A map of field types to react components.
 * @param {string} formName - The name of the form.
 * @param {object} schema  - The schema to use.
 * @param {object} reduxFormOptions - Optional options object for `redux-form`.
 * @returns {object} - The form react element.
 */

export default function form(UIKit, formName, schema, reduxFormOptions) {
  var fields = createFields(UIKit, formName, schema);

  var Form = function Form(_ref) {
    var className = _ref.className,
        disabled = _ref.disabled;
    return React.createElement('form', {
      className: className
    }, React.createElement('fieldset', {
      className: className && className + '-fieldset',
      style: {
        border: 'none',
        margin: '0 10px',
        padding: '0 30px'
      },
      disabled: disabled
    }, React.createElement('div', {
      className: className && className + '-fieldset-fields',
      style: {
        display: 'flex',
        flexFlow: 'row wrap'
      }
    }, fields)));
  };

  Form.propTypes = process.env.NODE_ENV !== "production" ? {
    // Modifiers
    className: PropTypes.string,
    disabled: PropTypes.bool
  } : {};
  Form.defaultProps = {
    // Modifiers
    className: '',
    disabled: false
  };
  return {
    Form: reduxForm(_extends({
      form: formName
    }, reduxFormOptions))(Form),
    isInvalid: isInvalid(formName),
    submit: function submit() {
      return _submit(formName);
    }
  };
}